
import { defineComponent } from 'vue'
import AppContent from '@/components/layout/AppContent.vue'
import { store } from '@/store'
import { toast } from '@/api/tools'

export default defineComponent({
  name: 'AppFooter',
  components: { AppContent },
  setup() {

    const subscription = store.user.get(state => state.subscription)

    function shareLove() {
      toast({title: 'Tak fordi du deler kærligheden!', type: 'love'})
    }
    
    return { subscription, shareLove }
  }
})
